module.exports = __webpack_public_path__ + "static/media/back-cloud@2x.1df2247a.png";